const config = {
  apiUrl: process.env.REACT_APP_API_URL,
  clientApiUrl: process.env.REACT_APP_CLIENT_API_URL,
  liveHub: 'liveHub',
};

export default config;
